import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { getPositionHistoryLogs } from '../api/positionApi';

type UseAuditLogsResponse = {
  data: HistoryLogEntryResponse[],
  isLoading: boolean,
  isError: boolean,
  error: AxiosError | null,
  isFetching: boolean,
  refetch: () => void,

}

export const useHistoryLogsPosition = (
  accountId: string,
  positionId: string,
  onCallback: () => void,
):UseAuditLogsResponse => {
  const {
    data,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  } = useQuery<HistoryLogResponse, AxiosError>(
    ['history', accountId, positionId],
    () => {
      return getPositionHistoryLogs(accountId, positionId);
    }, {
      onSuccess: () => {
        onCallback();
      },
      enabled: !!accountId && !!positionId,
      retry: false,
    });

  return {
    data: data?.logs || [],
    isLoading,
    isError,
    error,
    isFetching,
    refetch,
  };
};
